<div class="modal-container" *transloco="let t; prefix: 'driverDocuments'">
  <div class="modal-container__header">
    <span class="modal-container__header-title">{{ t('upload.title') }}</span>
    <button class="modal-container__header-btn" (click)="closeModal()" [title]="'common.close' | transloco">
      <svg class="modal-container__header-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.1959 6.34399L11.9529 10.586L7.71087 6.34399L6.29688 7.75799L10.5389 12L6.29688 16.242L7.71087 17.656L11.9529 13.414L16.1959 17.656L17.6099 16.242L13.3679 12L17.6099 7.75799L16.1959 6.34399Z" fill="#9FA1A4"/>
      </svg>
    </button>
  </div>
  <div class="modal-container__body">
    <div class="modal-form">
      @if (showDriversLicenseWarning) {
        <div class="modal-form__warning">
          <svg width="28" height="28" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0 22C0 9.84974 9.84974 0 22 0C34.1503 0 44 9.84974 44 22C44 34.1503 34.1503 44 22 44C9.84974 44 0 34.1503 0 22Z"
              fill="#FF7F00" />
              <path
                d="M22.8842 12.532C22.5382 11.878 21.4622 11.878 21.1162 12.532L12.1162 29.532C11.9522 29.842 11.9622 30.216 12.1432 30.515C12.3242 30.816 12.6492 31 13.0002 31H31.0002C31.3512 31 31.6762 30.816 31.8562 30.516C32.0382 30.216 32.0472 29.842 31.8832 29.533L22.8842 12.532ZM23.0002 28H21.0002V26H23.0002V28ZM21.0002 24V19H23.0002L23.0012 24H21.0002Z"
                fill="#F7F5F5" />
              </svg>
              <span>{{ t('upload.licenseRequired') }}</span>
            </div>
          }
          <div class="modal-form__document-info">
            <label class="modal-label">{{ t('upload.documentType') }}</label>
            <div class="dropdown-input-wrapper" (click)="toggleDropdown()">
              <input class="modal-input" type="text" placeholder="{{(selectedDocumentType | documentTypeLabel) || t('upload.selectDocumentType')}}" [title]="t('upload.documentTypes')" readonly />
              <svg class="dropdown-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.862 6.19534L7.99998 9.05734L5.13798 6.19534L4.19531 7.13801L7.99998 10.9427L11.8046 7.13801L10.862 6.19534Z" fill="#9FA1A4"/>
              </svg>
            </div>
            <!-- dropdown menu -->
            @if (dropdownOpen) {
              <ul class="modal-dropdown-menu" [ngStyle]="{'max-height': getDropdownHeight()}">
                @for (doc of availableDocumentTypes; track doc) {
                  <li (click)="selectDocument(doc)">
                    {{ doc.name | documentTypeLabel }}
                  </li>
                }
              </ul>
            }
          </div>

          @if (selectedDocumentType === 'Other') {
            <div class="modal-form__document-renewal">
              <div class="modal-form__document-renewal__date">
                <label class="modal-label">{{ t('upload.documentName') }} <span class="required-asterisk">*</span></label>
                <input type="text" class="modal-input document-name-input" [(ngModel)]="otherDocumentName" [placeholder]="t('upload.enterDocumentName')" required />
              </div>
              <div class="modal-toggle">
                <label class="switch">
                  <input type="checkbox" [(ngModel)]="otherDocumentExpires" />
                  <span class="slider round"></span>
                </label>
                <span>{{ t('upload.hasExpiryDate') }}</span>
              </div>
            </div>
          }
          @if (selectedDocumentType === 'Other' && otherDocumentExpires) {
            <div class="modal-form__document-renewal__date">
              <app-flatpickr-date-picker
                [label]="t('upload.renewalDate')"
                [(value)]="documentRenewalDate">
              </app-flatpickr-date-picker>
            </div>
          }

          @if (selectedDocumentType && documentTypeExpires) {
            <div class="modal-form__document-renewal">
              @if (documentTypeExpires && documentTypeName === 'Drivers License') {
                <div class="modal-toggle">
                  <label class="switch">
                    <input type="checkbox" [(ngModel)]="hasLicensePdp" [disabled]="isProfessionalDrivingPermitUploaded" />
                    <span class="slider round"></span>
                  </label>
                  <span [ngClass]="{'disabled-text': isProfessionalDrivingPermitUploaded}">{{ t('fields.licenseContainsPdp') }}</span>
                  @if (isProfessionalDrivingPermitUploaded) {
                    <span class="tooltip-icon-wrapper" [title]="t('upload.alreadyUploaded')">
                      <svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.2" d="M28 16C28 18.3734 27.2962 20.6935 25.9776 22.6668C24.6591 24.6402 22.7849 26.1783 20.5922 27.0866C18.3995 27.9948 15.9867 28.2324 13.6589 27.7694C11.3312 27.3064 9.19295 26.1635 7.51472 24.4853C5.83649 22.8071 4.6936 20.6689 4.23058 18.3411C3.76756 16.0133 4.0052 13.6005 4.91345 11.4078C5.8217 9.21509 7.35977 7.34094 9.33316 6.02236C11.3066 4.70379 13.6266 4 16 4C19.1826 4 22.2348 5.26428 24.4853 7.51472C26.7357 9.76515 28 12.8174 28 16Z" fill="#9FA1A4"/>
                        <path d="M18 22C18 22.2652 17.8946 22.5196 17.7071 22.7071C17.5196 22.8946 17.2652 23 17 23C16.4696 23 15.9609 22.7893 15.5858 22.4142C15.2107 22.0391 15 21.5304 15 21V16C14.7348 16 14.4804 15.8946 14.2929 15.7071C14.1054 15.5196 14 15.2652 14 15C14 14.7348 14.1054 14.4804 14.2929 14.2929C14.4804 14.1054 14.7348 14 15 14C15.5304 14 16.0391 14.2107 16.4142 14.5858C16.7893 14.9609 17 15.4696 17 16V21C17.2652 21 17.5196 21.1054 17.7071 21.2929C17.8946 21.4804 18 21.7348 18 22ZM29 16C29 18.5712 28.2376 21.0846 26.8091 23.2224C25.3807 25.3603 23.3503 27.0265 20.9749 28.0104C18.5995 28.9944 15.9856 29.2518 13.4638 28.7502C10.9421 28.2486 8.6257 27.0105 6.80762 25.1924C4.98953 23.3743 3.75141 21.0579 3.2498 18.5362C2.74819 16.0144 3.00563 13.4006 3.98957 11.0251C4.97351 8.64968 6.63975 6.61935 8.77759 5.1909C10.9154 3.76244 13.4288 3 16 3C19.4467 3.00364 22.7512 4.37445 25.1884 6.81163C27.6256 9.24882 28.9964 12.5533 29 16ZM27 16C27 13.8244 26.3549 11.6977 25.1462 9.88873C23.9375 8.07979 22.2195 6.66989 20.2095 5.83733C18.1995 5.00476 15.9878 4.78692 13.854 5.21136C11.7202 5.6358 9.76021 6.68345 8.22183 8.22183C6.68345 9.7602 5.63581 11.7202 5.21137 13.854C4.78693 15.9878 5.00477 18.1995 5.83733 20.2095C6.66989 22.2195 8.07979 23.9375 9.88873 25.1462C11.6977 26.3549 13.8244 27 16 27C18.9164 26.9967 21.7123 25.8367 23.7745 23.7745C25.8367 21.7123 26.9967 18.9164 27 16ZM15.5 12C15.7967 12 16.0867 11.912 16.3334 11.7472C16.58 11.5824 16.7723 11.3481 16.8858 11.074C16.9994 10.7999 17.0291 10.4983 16.9712 10.2074C16.9133 9.91639 16.7704 9.64912 16.5607 9.43934C16.3509 9.22956 16.0836 9.0867 15.7926 9.02882C15.5017 8.97094 15.2001 9.00065 14.926 9.11418C14.6519 9.22771 14.4176 9.41997 14.2528 9.66665C14.088 9.91332 14 10.2033 14 10.5C14 10.8978 14.158 11.2794 14.4393 11.5607C14.7206 11.842 15.1022 12 15.5 12Z" fill="#9FA1A4"/>
                      </svg>
                    </span>
                  }
                </div>
              }
              @if (documentTypeExpires && !(documentTypeName === 'Drivers License' && hasLicensePdp)) {
                <div class="modal-form__document-renewal__date">
                  <app-flatpickr-date-picker
                    [label]="t('fields.renewalDateFor', { name: selectedDocumentType })"
                    [(value)]="documentRenewalDate">
                  </app-flatpickr-date-picker>
                </div>
              }
              @if (selectedDocumentType === 'Drivers License' && hasLicensePdp) {
                <div class="modal-form__document-renewal__date-row">
                  <div class="modal-form__document-renewal__date">
                    <app-flatpickr-date-picker
                      [label]="t('fields.renewalDateFor', { name: selectedDocumentType })"
                      [(value)]="documentRenewalDate"
                      [disabled]="!selectedDocumentType">
                    </app-flatpickr-date-picker>
                  </div>
                  <div class="modal-form__document-renewal__date">
                    <app-flatpickr-date-picker
                      [label]="t('fields.pdpRenewalDate')"
                      [(value)]="licensePdpRenewalDate"
                      [disabled]="!selectedDocumentType">
                    </app-flatpickr-date-picker>
                  </div>
                </div>
              }
            </div>
          }

          <div class="modal-upload">
            <input type="file" accept=".pdf" hidden (change)="onFileSelected($event)" #fileInput />
            <button class="modal-upload-btn" type="button" (click)="fileInput.click()"
              [disabled]="!canUploadSelectedDocument"
              >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 19V15H16L12 10L8 15H11V19H13Z" fill="#ee2737"/>
                <path d="M7 19H9V17H7C5.346 17 4 15.654 4 14C4 12.596 5.199 11.244 6.673 10.985L7.254 10.883L7.446 10.325C8.149 8.274 9.895 7 12 7C14.757 7 17 9.243 17 12V13H18C19.103 13 20 13.897 20 15C20 16.103 19.103 17 18 17H15V19H18C20.206 19 22 17.206 22 15C22 13.12 20.695 11.538 18.944 11.112C18.507 7.67 15.56 5 12 5C9.244 5 6.85 6.611 5.757 9.15C3.609 9.792 2 11.82 2 14C2 16.757 4.243 19 7 19Z" fill="#ee2737"/>
              </svg>
              <span class="modal-upload-btn-text">{{ t('actions.upload') }}</span>
            </button>
          </div>

          <!-- Upload Progress Bar -->
          @if (uploadedDocuments.length) {
            <div class="upload-status-list">
              @for (doc of uploadedDocuments; track doc) {
                <div class="upload-status">
                  <div class="upload-status-info-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M19.937 8.68C19.926 8.648 19.917 8.617 19.904 8.586C19.855 8.48 19.794 8.379 19.708 8.293L13.708 2.293C13.622 2.207 13.521 2.146 13.415 2.097C13.385 2.083 13.353 2.075 13.321 2.064C13.237 2.036 13.151 2.018 13.062 2.013C13.04 2.011 13.021 2 13 2H6C4.897 2 4 2.897 4 4V20C4 21.103 4.897 22 6 22H18C19.103 22 20 21.103 20 20V9C20 8.979 19.989 8.96 19.987 8.938C19.982 8.85 19.965 8.764 19.937 8.68ZM16.586 8H14V5.414L16.586 8ZM6 20V4H12V9C12 9.553 12.447 10 13 10H18L18.002 20H6Z" fill="#9FA1A4"/>
                    </svg>
                  </div>
                  <div class="upload-status-info-text">
                    <span>{{ doc.documentName | documentTypeLabel }}</span>
                    @if (doc.uploading) {
                      <div class="upload-status-progress-bar-container">
                        <div class="upload-status-progress-bar" [style.width.%]="doc.uploadProgress"></div>
                      </div>
                    }
                    @if (doc.uploadSuccess) {
                      <div class="upload-status-success">
                        {{ t('upload.fileUploaded') }}
                      </div>
                    }
                  </div>
                  @if (doc.uploading) {
                    <div class="upload-status-percentage">
                      <span>{{ doc.uploadProgress }}%</span>
                    </div>
                  }
                  <div class="upload-status-delete-file">
                    @if (doc.uploadSuccess) {
                      <button class="upload-status-delete-file-btn" (click)="openDeleteDriverDocumentConfirmationModal(doc)" [title]="t('actions.deleteFile')">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5 20C5 21.103 5.897 22 7 22H17C18.103 22 19 21.103 19 20V8H21V6H17V4C17 2.897 16.103 2 15 2H9C7.897 2 7 2.897 7 4V6H3V8H5V20ZM9 4H15V6H9V4ZM17 8L17.001 20H7V8H17Z" fill="#9FA1A4"/>
                          <path d="M9 10H11V18H9V10ZM13 10H15V18H13V10Z" fill="#9FA1A4"/>
                        </svg>
                      </button>
                    }
                  </div>
                </div>
              }
            </div>
          }
          <div class="modal-actions">
            <button class="modal-btn cancel" (click)="closeModal()">{{ 'common.cancel' | transloco }}</button>
            <button class="modal-btn save" [disabled]="!allUploadsSuccessful() || isLoading" (click)="saveChanges()">
              @if (isLoading) {
                <span class="spinner-border"></span>
              }
              @if (!isLoading) {
                <span>{{ 'common.saveChanges' | transloco }}</span>
              }
            </button>
          </div>
        </div>
      </div>